module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200@2x-bda72991cd4d5e4113a0c51562e178be.jpg";